import breakpoint from "./breakpoint";
import classnames from "./classnames";

// ENUMS
// eslint-disable-next-line no-shadow
export enum AlertType {
  Info = "info",
  Warning = "warning",
  Error = "error",
  Success = "success",
}

// eslint-disable-next-line no-shadow
export enum TabType {
  Branches = "branches",
  Atms = "atms",
}

// eslint-disable-next-line no-shadow
export enum ExchangeRatesTableType {
  Cash = "cash",
  Wire = "wire",
}

// INTERFACE
export interface GeoCoordinates {
  lat: number;
  lng: number;
}

// TYPES
type BreakpointType = {
  xxs: number;
  sm: number;
  md: number;
};

type ClassNamesType = {
  ACTIVE: string;
  INVISIBLE: string;
  HIDDEN: string;
  IS_OPEN: string;
};

// type for Key/Value pair of checkbox
export type CheckboxKeyValueType = {
  [key: string]: boolean;
};

// CONSTANTS
// ===== Branches and Atms
export const SEARCH_FORM_BRANCHES = "js-branches-search-form";
export const SEARCH_FORM_ATMS = "js-atms-search-form";
export const GEO_COORDINATES_FROM_BROWSER = "geo_coordinates_from_browser";
export const GEO_COORDINATES_FROM_SEARCH = "geo_coordinates_from_search";
export const SEARCH_FORM_GENERAL = "js-search-list-form";

export const OPENING_HOURS = "opening-hours";
export const HANDICAPED = "handicaped";
export const COMPANIES = "companies";
export const SERVICES = "services";
export const MORE = "more";
export const ALL = "all";

export const DESKTOP = "desktop";
export const MOBILE = "mobile";

// API calls
export const LOAD_3_ITEMS = 3;
export const LOAD_10_ITEMS = 10;

// ===== Geolocation
// Fallback is 'Prague Vaclavske Namesti'
export const FALLBACK_COORDINATES: GeoCoordinates = {
  lat: 50.0812,
  lng: 14.4271,
};

// ===== Misc
export const BREAKPOINT = breakpoint as BreakpointType;
export const CLASSNAMES = classnames as ClassNamesType;
export const WIDGET_DATA_ATTR = "widget_id";
